(() => {
  // patch original clickDate method to disallow selecting range with invalid dates in it
  const clickDate = daterangepicker.prototype.clickDate;
  daterangepicker.prototype.clickDate = function (event) {
    if (this.container.find('.in-range:not(.available)').length) return;
    return clickDate.call(this, event);
  };
})();